<template>
  <stat :title="$t('dashboard.newvsreturning.title')" :loading="loading">
    <new-vs-returning-chart
      v-if="totalResults !== 0"
      :dataKey="dataKey"
      :height="200"
      :params="params"
      style="width: 100%"></new-vs-returning-chart>
    <small v-else>{{ $t('dashboard.newvsreturning.notActivated') }}</small>
  </stat>
</template>

<script>
  import { NewVsReturningChart } from '@/components/charts'
  import stats from '@/mixins/stats'
  export default {
    components: {
      NewVsReturningChart
    },
    mixins: [stats],
    props: {
      dataKey: {
        type: String,
        default: 'newVsReturning'
      }
    }
  }
</script>

<style scoped>
  small { font-size: .5em; }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/NewVsReturning.vue